import { FC, Fragment } from 'react';
import { BodyText, Button, ButtonGroup, Form, Modal } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';

import { AccountSettingsStore } from '../stores/account-settings.store';

export const ChangePasswordModal: FC = observer(() => {
    const [{ changePasswordForm, changePasswordLoading, closeModal, changePassword }] =
        useDependencies(AccountSettingsStore);

    const { oldPassword, password, confirmPassword } = changePasswordForm.$;

    return (
        <Modal
            size={Modal.Sizes.S}
            open
            onClose={closeModal}
            closable
            title="Change Password"
            footer={
                <ButtonGroup>
                    <Button id="change_password_cancel_btn" onClick={closeModal}>
                        Cancel
                    </Button>
                    <Button
                        id="change_password_change_btn"
                        onClick={changePassword}
                        loading={changePasswordLoading}
                        primary
                    >
                        Change Password
                    </Button>
                </ButtonGroup>
            }
        >
            <Form>
                <Form.Input
                    id="change_password_old_password"
                    type="password"
                    value={oldPassword.value}
                    onChange={oldPassword.onChangeHandler}
                    label="Old Password"
                    required
                    error={oldPassword.error}
                />

                <Form.Input
                    id="change_password_new_password"
                    type="password"
                    value={password.value}
                    onChange={password.onChangeHandler}
                    label="Create New Password"
                    required
                    error={password.error}
                />

                <Form.Input
                    id="change_password_confirm_password"
                    type="password"
                    value={confirmPassword.value}
                    onChange={confirmPassword.onChangeHandler}
                    label="Repeat New Password"
                    required
                    error={confirmPassword.error}
                    description={
                        <Fragment>
                            <BodyText subdued size="small" className="m-t-2 m-b-half">
                                Use 10 or more characters
                            </BodyText>
                            <BodyText subdued size="small" className="m-b-half">
                                Use at least one uppercase and one lowercase letter (Aa)
                            </BodyText>
                            <BodyText subdued size="small">
                                Passwords must match
                            </BodyText>
                        </Fragment>
                    }
                />
            </Form>
        </Modal>
    );
});
